import { apiFetchAccounts } from './apiAccounts';
import type {
  PlanningAlert,
  PlanningAlertCriteria,
  PlanningAlertMatchesResponse,
  PlanningAlertQuote,
  PlanningAlertsListResponse,
  PlanningAlertStatus,
} from '../types/alerts';

export async function listAlerts(): Promise<PlanningAlertsListResponse> {
  return apiFetchAccounts('/alerts', { method: 'GET' });
}

export async function quoteAlert(criteria: PlanningAlertCriteria): Promise<PlanningAlertQuote> {
  return apiFetchAccounts('/alerts/quote', {
    method: 'POST',
    body: JSON.stringify(criteria),
  });
}

export async function createAlert(body: { name: string; criteria: PlanningAlertCriteria }): Promise<PlanningAlert> {
  return apiFetchAccounts('/alerts', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export async function updateAlert(
  id: string,
  patch: { name?: string; status?: PlanningAlertStatus; criteria?: PlanningAlertCriteria },
): Promise<PlanningAlert> {
  return apiFetchAccounts(`/alerts/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    body: JSON.stringify(patch),
  });
}

export async function deleteAlert(id: string): Promise<void> {
  await apiFetchAccounts(`/alerts/${encodeURIComponent(id)}`, {
    method: 'DELETE',
  });
}

export async function listAlertMatches(id: string, limit = 50): Promise<PlanningAlertMatchesResponse> {
  return apiFetchAccounts(`/alerts/${encodeURIComponent(id)}/matches?limit=${limit}`, { method: 'GET' });
}
